// ThemeToggle — light/dark switch in the landing header.

import type { JSX } from "react";
import { Moon, Sun } from "lucide-react";
import { useI18n } from "../../i18n";
import { useTheme } from "../../hooks/useTheme";

export function ThemeToggle(): JSX.Element {
  const { t } = useI18n();
  const { theme, toggle } = useTheme();
  const isLight = theme === "light";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={isLight}
      aria-label={t("landing.header.lightMode")}
      title={t("landing.header.lightMode")}
      data-testid="theme-toggle"
      className="inline-flex h-8 w-8 items-center justify-center border border-[var(--color-line-strong)] bg-[var(--color-slab)] text-[var(--color-ink)] transition-colors hover:text-[var(--color-lime)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-lime)]"
      style={{ borderRadius: "var(--radius-sharp)" }}
    >
      {isLight ? <Moon size={16} aria-hidden="true" /> : <Sun size={16} aria-hidden="true" />}
    </button>
  );
}
